import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import React, { useState } from "react";

type Props = {
  title: string | React.ReactNode;
  children: React.ReactElement;
  [key: string]: any;
};

const FilterDropdown: React.FC<Props> = ({ title, children, ...props }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <DropdownMenu open={open} onOpenChange={(e: boolean) => setOpen(e)}>
        <DropdownMenuTrigger asChild {...props}>
          <Button variant="outline">{title}</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className={cn(["w-[358px]",props.className])}>
          <div className="flex items-center justify-between h-[64px] px-[20px]">
            <p className="font-[600] select-none">Filter</p>
            <X
              size={16}
              className="cursor-pointer"
              onClick={() => setOpen(false)}
            />
          </div>
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default FilterDropdown;
